const formatLocation = (city?: string, stateProvince?: string): string => {
  let location = '';
  if (city && stateProvince) {
    location = `${city}, ${stateProvince}`;
  } else if (city) {
    location = city;
  } else if (stateProvince) {
    location = stateProvince;
  }
  return location;
};

export default formatLocation;
